/*
  {params}
  page : 현재 페이지
  pageRow : 한 페이지에 보이는 리스트 수
  pageBlock :  페이징에 보이는 페이징 수
  totalCount : 총 리스트 수

  {custom}
  pageClick : 해당 페이지로 이동
*/
import React, { Component } from 'react';

import { Menu, Icon } from 'semantic-ui-react';

class Pagination extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    // prop 이름은 pageRow 다. pagerow 로 읽으면 항상 undefined 라
    // 페이지당 갯수만 바뀌었을 때 총 페이지 수가 갱신되지 않는다.
    const { page, pageRow, totalCount } = this.props;

    return page !== nextProps.page || pageRow !== nextProps.pageRow || totalCount !== nextProps.totalCount;
  }

  setPagination = () => {
    const { page, pageRow, pageBlock, totalCount } = this.props;

    //총 페이지
    const totalPage = totalCount % pageRow ? Math.floor(totalCount / pageRow) + 1 : totalCount / pageRow;
    //총 페이지블락
    const totalBlock = Math.ceil(totalPage / pageBlock);
    //현재 페이지 블락
    const currentBlock = page <= pageBlock ? 1 : Math.ceil(page / pageBlock);
    //현재 블럭의 시작 페이지
    const startPage = currentBlock * pageBlock - pageBlock + 1;
    //현재 블럭의 마지막 페이지
    const endPage = currentBlock === totalBlock ? totalPage : currentBlock * pageBlock;

    return {
      startPage: startPage,
      endPage: endPage,
      totalPage: totalPage,
      totalBlock: totalBlock,
      currentBlock: currentBlock
    };
  };

  render() {
    const { page, pageRow, pageBlock, totalCount, pageClick, prevClick, nextClick } = this.props;
    const { startPage, endPage, totalPage, totalBlock, currentBlock } = this.setPagination();

    let paging = [];
    if (totalPage >= 1) {
      for (let i = startPage; i <= endPage; i++) {
        if (i !== page) {
          paging.push(
            <Menu.Item as="a" key={i} active={page === i} onClick={() => pageClick(i)}>
              {i}
            </Menu.Item>
          );
        } else {
          paging.push(
            <Menu.Item as="a" key={i} active={page === i}>
              {i}
            </Menu.Item>
          );
        }
      }

      if (totalBlock > 1) {
        const endKey = endPage + 1;
        const startKey = startPage - 1;

        if (currentBlock === 1) {
          paging.push(
            <Menu.Item as="a" key={endKey} icon onClick={() => pageClick(endKey)}>
              <Icon name="play" />
            </Menu.Item>
          );

          if (endKey !== totalPage) {
            paging.push(
              <Menu.Item as="a" key={totalPage} icon onClick={() => pageClick(totalPage)}>
                <Icon name="step forward" />
              </Menu.Item>
            );
          }
        } else if (currentBlock === totalBlock) {
          paging.unshift(
            <Menu.Item as="a" key={startKey} icon onClick={() => pageClick(startKey)}>
              <Icon flipped="horizontally" name="play" />
            </Menu.Item>
          );
          paging.unshift(
            <Menu.Item as="a" key={1} icon onClick={() => pageClick(1)}>
              <Icon flipped="horizontally" name="step forward" />
            </Menu.Item>
          );
        } else {
          paging.unshift(
            <Menu.Item as="a" key={startKey} icon onClick={() => pageClick(startKey)}>
              <Icon flipped="horizontally" name="play" />
            </Menu.Item>
          );
          paging.unshift(
            <Menu.Item as="a" key={1} icon onClick={() => pageClick(1)}>
              <Icon name="backward" />
            </Menu.Item>
          );
          paging.push(
            <Menu.Item as="a" key={endKey} icon onClick={() => pageClick(endKey)}>
              <Icon name="play" />
            </Menu.Item>
          );
          paging.push(
            <Menu.Item as="a" key={totalPage} icon onClick={() => pageClick(totalPage)}>
              <Icon name="step forward" />
            </Menu.Item>
          );
        }
      }
    } else {
      paging.push(
        <Menu.Item as="a" key={1} active>
          1
        </Menu.Item>
      );
    }

    return <Menu pagination>{paging}</Menu>;
  }
}

export default Pagination;
